<template>
    <div class="file-upload" v-bind:key="id">
        <div class="large-12 medium-12 small-12 filezone" v-if="imageurl === null || placeholderImage === true">
            <input type="file" class="file" ref="fileinput" accept=".gif,.jpg,.jpeg,.png" v-on:change="uploadFile()"/>
            <p v-if="!uploading">Drop your file here <br>or click to search</p>
            <p v-if="uploading"><img src="/img/spinner-gray.gif" width="30" height="30"><br>Uploading...</p>
        </div>
        <div class="file-preview" v-else-if="loaded && imageurl && placeholderImage === false">
            <img v-bind:src="displayImageUrl(imageurl)" v-bind:style="imageMaxWidth()">
            <div class="croploading d-flex align-items-center justify-content-center" v-if="cropLoading">
                <p><img src="/img/spinner-gray.gif" width="30" height="30"><br>Cropping...</p>
            </div>
        </div>
        <div class="invalid-feedback" v-if="error" v-text="errorMessage"></div>
        <div class="image-actions d-flex align-items center justify-content-end" v-if="imageurl && placeholderImage === false">
            <button type="button" class="btn btn-primary btn-sm crop-image" v-on:click.prevent="showCroppie(true)" v-if="showCropButton()">Crop Image</button>
            <button type="button" class="btn btn-danger btn-sm delete-image" v-on:click.prevent="deleteImage()">Remove Image</button>
        </div>

        <div id="crop-modal" class="crop-modal modal" v-bind:class="{ show: showCropModal, 'ui-light-theme' : lightTheme }" tabindex="-1" role="dialog" aria-modal="true" v-if="showCropModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Crop Image</h5>
                        <button type="button" class="close" v-on:click.prevent="showCroppie(false)" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <vue-croppie 
                            ref="croppieRef" 
                            :enableOrientation="false"
                            :enableResize="cropResize" 
                            :viewport="cropViewport"
                            @result="result"
                            @update="update">
                        </vue-croppie>
                        <div class="crop-modes d-flex align-items-center justify-content-start" v-if="loadEditable == 'no'">
                            <button class="free-crop-btn btn" v-bind:class="selectedCropModeClass('freecrop')" v-on:click.prevent="changeCropMode('freecrop')">Free Crop</button>
                            <button class="circle-crop-btn btn" v-bind:class="selectedCropModeClass('circle')" v-on:click.prevent="changeCropMode('circle')">Circle Crop</button>
                            <button class="square-crop-btn btn" v-bind:class="selectedCropModeClass('square')" v-on:click.prevent="changeCropMode('square')">Square Crop</button>
                        </div>
                        <select class="crop-mode form-control" v-model="cropType" v-on:change="changeCropMode()">
                            <option value="freecrop">Free Crop</option>
                            <option value="circle">Circle</option>
                            <option value="square">Square</option>
                        </select>
                        <div class="crop-actions d-flex align-items-center justify-content-end">
                            <button class="crop-btn btn btn-primary" v-bind:class="{ 'loading': cropLoading }" v-on:click.prevent="crop()">Crop Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- .crop-modal -->
    </div><!-- .file-upload -->

    
</template>

<script>
    export default {
        props: {
            signatureId: {
                type: Number,
                default: null,
            },
            loadImageId: {
                type: Number,
                default: null,
            },
            loadParentId: {
                type: Number,
                default: null,
            },
            loadCropParentId: {
                type: Number,
                default: null,
            },
            loadImageUrl: {
                type: String,
                default: null,
            },
            loadOriginalImageUrl: {
                type: String,
                default: null,
            },
            loadImageWidth: {
                type: Number,
                default: 600,
            },
            loadCropping: {
                type: String,
                default: 'freecrop',
            },
            loadEditable: {
                type: String,
                default: "no",
            },
            loadUncroppable: {
                type: Boolean,
                default: false,
            },
            placeholderImage: {
                type: Boolean,
                default: false,
            },
            imageRootUrl: String,
            theme: {
                type: String,
                default: 'dark'
            },
        },
        data() {
            return {
                imageurl: null,
                originalImageUrl: null,
                showCropModal: false,
                id: null,
                parentId: null,
                cropParentId: null,
                uploading: false,
                cropType: this.loadCropping,
                cropResize: true,
                cropViewport: { width: 300, height: 300, type: this.loadCropping, enableResize: false },
                cropLoading: false,
                error: null,
                errorMessage: null,
                uncroppable: false,
                loaded: false,
            }
        },
        watch: { 
            loadImageId: function(newVal, oldVal) {
                this.id = newVal;
            },
            loadImageUrl: function(newVal, oldVal) {
                this.imageurl = newVal;
            },
            loadCropParentId: function(newVal, oldVal) {
                this.cropParentId = newVal;
            },
            loadImageWidth: function(newVal, oldVal) {
                this.resizeImage();
            },
            loadCropping: function(newVal, oldVal) {
                this.cropType = newVal;
                this.checkCropMode();
                if (this.showCropModal === true && this.$refs.croppieRef) {
                    this.$nextTick(() => {
                        this.$refs.croppieRef.refresh();
                        this.$refs.croppieRef.bind({
                            url: this.imageRootUrl + "/" + this.originalImageUrl,
                        });
                    });
                }
            }
        },
        mounted: function() {
            if (this.loadImageId && this.loadImageUrl) {
                this.id = this.loadImageId;
                this.imageurl = this.loadImageUrl;
                if (this.loadParentId) {
                    this.parentId = this.loadParentId;
                }
                if (this.loadCropParentId) {
                    this.cropParentId = this.loadCropParentId;
                }
                if (this.loadOriginalImageUrl) {
                    this.originalImageUrl = this.loadOriginalImageUrl;
                } else {
                    this.originalImageUrl = this.loadImageUrl;
                }
                if (this.loadUncroppable) {
                    this.uncroppable = this.loadUncroppable;
                }
            }
            this.checkCropMode();
            this.$nextTick(() => {
                this.loaded = true;
            });
        },
        computed: {
            lightTheme: function() {
                if (this.theme == 'light') {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            displayImageUrl: function(imageUrl) {
                return this.imageRootUrl + "/" + imageUrl;
            },
            imageMaxWidth() {
                if (this.loadImageWidth < 284) {
                    return "max-width:" + this.loadImageWidth + "px";
                } else {
                    return null;
                }
            },
            uploadFile() {
                var self = this;
                this.uploading = true;
                this.error = null;
                let fileToUpload = this.$refs.fileinput.files[0];
                let formData = new FormData();
                formData.append('image', fileToUpload);
                //console.log(fileToUpload);
                formData.append('filetype', 'jpeg');
                formData.append('width', this.loadImageWidth);
                if (this.signatureId) {
                    formData.append('signature_id', this.signatureId);
                }
                axios.post('/image/upload',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function(response) {
                    // self.screenshots.unshift(response.data);
                    self.uploading = false;
                    //console.log(response.data);
                    // self.filesToUpload = [];
                    if (response.data.image) {
                        var image = {};
                        image.imageurl = response.data.image;
                        if (response.data.parent_image) {
                            image.originalImageUrl = response.data.parent_image;
                        } else {
                            image.originalImageUrl = image.imageurl;
                        }
                        self.imageurl = image.imageurl;
                        self.originalImageUrl = image.originalImageUrl;
                        image.id = response.data.id;
                        image.parentId = response.data.parent_id;
                        if (self.cropParentId) {
                            image.cropParentId = self.cropParentId;
                        }
                        image.width = response.data.width;
                        image.height = response.data.height;
                        self.id = image.id;
                        self.parentId = image.parentId;
                        if (response.data.uncroppable && response.data.uncroppable === true) {
                            image.uncroppable = true;
                            self.uncroppable = true;
                        }
                        self.$emit('updated', image);
                        if (self.loadEditable !== 'no' && (self.cropType == 'circle' || self.cropType == 'square')) {
                            if (self.uncroppable === false) {
                                self.showCroppie(true);
                            }
                        }
                    } else if (response.data.error) {
                        self.error = true;
                        self.errorMessage = response.data.message;
                        self.$refs.fileinput.value = '';
                    }
                }).catch(function(error) {
                    // console.log(error);
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    if (error.response && error.response.status && error.response.status == 419) {
                        Vue.notify({
                            group: 'bottomleftmessages',
                            title: 'The page has expired, please reload.',
                            type: 'error',
                        });
                    } else if (error.response && error.response.status && error.response.status == 413) {
                        self.error = true;
                        self.errorMessage = "Image should be 5MB or smaller";
                    } else {
                        self.error = true;
                        self.errorMessage = "Image could not be uploaded";
                    }
                    self.uploading = false;
                });
            },
            resizeImage() {
                if (this.id || this.cropParentId) {
                    if (this.uncroppable) {
                        //Ignore this.
                    } else {
                        var self = this;
                        this.cropLoading = true;
                        var data = { width: this.loadImageWidth };
                        
                        if (this.parentId && this.parentId !== '') {
                            data.parent = this.parentId;
                        } else {
                            data.parent = this.id;
                        }
                        if (this.cropParentId && this.cropParentId !== '') {
                            data.cropParent = this.cropParentId;
                        }
                        axios.post('/image/resize', data )
                        .then(function (response) {
                            var image = {};
                            image.imageurl = response.data.image;
                            // if (response.data.parent_image) {
                            //     image.originalImageUrl = self.awsUrl + "/" + response.data.parent_image;
                            // } else {
                            //     image.originalImageUrl = image.imageurl;
                            // }
                            self.imageurl = image.imageurl;
                            //self.originalImageUrl = image.originalImageUrl;
                            image.id = response.data.id;
                            image.parentId = response.data.parent_id;
                            if (self.cropParentId) {
                                image.cropParentId = self.cropParentId;
                            }
                            image.width = response.data.width;
                            image.height = response.data.height;
                            self.id = image.id;
                            self.$emit('updated', image);
                            self.cropLoading = false;
                        })
                        .catch(function (error) {
                            
                        });
                    }
                }
            },
            deleteImage() {
                var self = this;
                var saveid = self.id;
                self.imageurl = null;
                self.id = null;
                self.$emit('deleted');
                axios.post('/image/delete/' + saveid,{
                    _method: 'DELETE',
                    id: saveid,
                }).then(function(response) {
                    
                }).catch(function(response) {
                    console.log('error');
                });
            },
            showCropButton() {
                if (this.uncroppable) {
                    return false;
                } else if (this.cropType !== 'none' || this.loadEditable == 'no') { //was false
                    return true;
                }
            },
            showCroppie(value) {
                this.showCropModal = value;
                if (this.showCropModal === true) {
                    var timestamp = new Date().getTime();
                    console.log(this.imageRootUrl + "/" + this.originalImageUrl + '?v=' + timestamp);
                    this.$nextTick(() => {
                        this.$refs.croppieRef.bind({
                            url: this.imageRootUrl + "/" + this.originalImageUrl + '?v=' + timestamp, //'/img/banner-signatures.png' 
                        });
                    });
                }
            },
            checkCropMode() {
                if (this.cropType == 'freecrop') {
                    this.cropResize = true;
                    this.cropViewport = { enableResize: true };
                } else if (this.cropType == 'circle') {
                    this.cropResize = false;
                    this.cropViewport = { width: 250, height: 250, type: 'circle', enableResize: false };
                } else if (this.cropType == 'square') {
                    this.cropResize = false;
                    this.cropViewport = { width: 250, height: 250, type: 'square', enableResize: false };
                }
            },
            selectedCropModeClass(cropType) {
                if (this.cropType === cropType) {
                    return 'btn-primary';
                } else {
                    return 'btn-secondary';
                }
            },
            changeCropMode(cropType) {
                this.cropType = cropType;
                this.checkCropMode();
                if (this.showCropModal === true && this.$refs.croppieRef) {
                    this.$nextTick(() => {
                        var timestamp = new Date().getTime();
                        this.$refs.croppieRef.refresh();
                        this.$refs.croppieRef.bind({
                            url: this.imageRootUrl + "/" + this.originalImageUrl + '?v=' + timestamp,
                        });
                    });
                }
            },
            crop() {
                this.cropLoading = true;
                this.showCropModal = false;
                let options = {
                    type: 'base64',
                    format: 'jpeg',
                    size: 'original',
                }
                if (this.cropType == 'circle' || this.isPng(this.imageurl) ) {
                    options.format = 'png';
                }
                // if (this.cropType == 'freecrop') {
                //     options.size = { width: (this.loadImageWidth * 2) };
                // } else if (this.cropType == 'circle') {
                //     options.size = { width: (this.loadImageWidth * 2), height: (this.loadImageWidth * 2) };
                //     options.format = 'png';
                // } else if (this.cropType == 'square') {
                //     options.size = { width: (this.loadImageWidth * 2), height: (this.loadImageWidth * 2) };
                // }
                this.$refs.croppieRef.result(options, (output) => {
                    //this.cropped = output;
                    var self = this;
                    this.uploading = true;
                    let formData = new FormData();
                    formData.append('image', output);
                    formData.append('filetype', options.format);
                    formData.append('width', this.loadImageWidth);
                    formData.append('type', 'crop');
                    if (this.parentId && this.parentId !== '') {
                        formData.append('parent', this.parentId);
                    }
                    if (this.signatureId) {
                        formData.append('signature_id', this.signatureId);
                    }
                    axios.post('/image/upload',
                        formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(function(response) {
                        // self.screenshots.unshift(response.data);
                        self.uploading = false;
                        //console.log(response.data);
                        // self.filesToUpload = [];
                        if (response.data.image) {
                            var image = {};
                            image.imageurl = response.data.image;
                            image.originalImageUrl = self.originalImageUrl;
                            image.parentId = response.data.parent_id;
                            image.width = response.data.width;
                            image.height = response.data.height;
                            if (response.data.crop_parent_id) {
                                image.cropParentId = response.data.crop_parent_id;
                                self.cropParentId = image.cropParentId;
                            }
                            self.imageurl = image.imageurl;
                            image.id = response.data.id;
                            self.id = image.id;
                            self.$emit('updated', image);
                            self.cropLoading = false;
                        } else if (response.data.error) {
                            self.error = true;
                            self.errorMessage = response.data.message;
                            self.cropLoading = false;
                        }
                    }).catch(function(error) {
                        console.log('error');
                        self.uploading = false;
                        
                    });
                });
            },
            isPng(filename) {
                return filename.toLowerCase().indexOf('png') !== -1;
            },
            result(output) {
                //console.log(output);
                //this.cropped = output;
            },
            update(val) {
                //console.log(val);
            },
            // rotate(rotationAngle) {
            //     // Rotates the image
            //     this.$refs.croppieRef.rotate(rotationAngle);
            // }
        }
    }
</script>
